<template>
  <div class="home" id="home">
    <van-overlay :show="start">
      <div class="start-box" @click.stop>
        <img src="../static/start-title.png" class="start-title" alt="">
        <img src="../static/start-bar.gif" class="start-bar" v-show="!start_but" alt="">
        <img src="../static/start-but.png" class="start-but" v-show="start_but" @click="gotohome"  alt="">
      </div>
    </van-overlay>



    <div class="homebg" id="homebg">
      <!-- <img src="../static/light.png" class="light" alt=""> -->
      <audio id="audio" loop="loop" autoplay='autoplay' preload="auto" src="../static/bgm.mp3"></audio>
      <div class="but-box">
        <img src="../static/home-but1.png" class="but1" v-if="but" @click="toxupian" alt="">
        <img src="../static/home-but2.png" class="but2" v-if="but" @click="tobottom" alt="">
      </div>
      <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
      <img src="../static/homebg.jpg" class="bg-img" alt="">
      <img src="../static/home-title1.png" v-if="title1" class="title1" alt="">
      <img src="../static/home-title2.png" v-if="title2" class="title2" alt="">
      <img src="../static/home-title3.png" v-if="title3" class="title3" alt="">
      <img src="../static/home-title4.png" v-if="title4" class="title4" alt="">
      <img src="../static/home-title5.png" v-if="title5" class="title5" alt="">
      <div class="illustrate-box" v-if="bottom">
        <img src="../static/illustrate.png" id="myElement" @click="showIllustrate = true" class="illustrate" alt="">
        <img src="../static/hands.png" class="hands" alt="">
      </div>
      <div class="icon-box" v-if="bottom">
        <img src="../static/icon2-1.png" class="icon1" @click="tofangtan" alt="">
        <img src="../static/icon2-2.png" class="icon" @click="tojiabin" alt="">
        <img src="../static/icon2-3.png" class="icon" @click="tozhubo" alt="">
        <img src="../static/icon2-4.png" class="icon" @click="reju = true" alt="">
        <img src="../static/icon2-5.png" class="icon" @click="togushi" alt="">
        <!-- <img src="../static/icon2-6.png" class="icon" @click="tokanxi" alt=""> -->
        <img src="../static/icon-back.png" class="icon-bottom" @click="totop" alt="">
      </div>


    </div>

    <div v-show="xupian" class="fangtan">
      <video-player class="video-player vjs-custom-skin playerA" @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="xupian_mp4" :playsinline="true"
        :options="xupian_mp4">
      </video-player>
      <img src="../static/back.png" class="back" @click="closexupian" alt="">
    </div>

    <div v-show="zhubo" class="fangtan">
      <video-player class="video-player vjs-custom-skin playerA" @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="zhubo_mp4" :playsinline="true"
        :options="zhubo_mp4">
      </video-player>
      <img src="../static/back.png" class="back" @click="closezhubo" alt="">
    </div>

    <van-overlay :show="showIllustrate">
      <div class="wrapper" @click.stop>
        <div class="block">
          <!-- <img src="../static/illustrate-words.png" class="illustrate-words" alt=""> -->
          <!-- <img src="../static/icon1.png" class="icon1" alt="">
          <img src="../static/icon2.png" class="icon2" alt="">
          <img src="../static/icon3.png" class="icon3" alt="">
          <img src="../static/icon4.png" class="icon4" alt="">
          <img src="../static/icon5.png" class="icon5" alt="">
          <img src="../static/icon6.png" class="icon6" alt=""> -->
          <!-- <img src="../static/illustrate-icon.png" class="icon1" alt=""> -->
        </div>
        <img src="../static/back.png" class="back" @click="showIllustrate = false" alt="">
      </div>
    </van-overlay>
    <audio id="thejiabinaudio"  preload="auto" :src="jiabinaudio"></audio>
    <van-overlay :show="jiabin">

      
      <div class="jiabin-box" @click.stop>
        <div class="jiabin1" :class="jiabindong > 0 ? 'donghua' : ''" @touchstart="touchStart($event, 1)"
          @touchmove="touchMove" @touchend="touchEnd($event, 1)">
          <img src="../static/jiabin/jiabin2.png" class="jiabin-img" alt="">
          <img src="../static/laba.gif" class="laba" alt="">

          <img src="../static/jiabin/tips.png" class="tips" alt="">
        </div>
        <div class="jiabin2" :class="jiabindong > 1 ? 'donghua' : ''" @touchstart="touchStart($event, 2)"
          @touchmove="touchMove" @touchend="touchEnd($event, 2)">
          <img src="../static/jiabin/jiabin1.png" class="jiabin-img" alt="">
          <img src="../static/laba.gif" class="laba" alt="">
          <img src="../static/jiabin/tips.png" class="tips" alt="">
        </div>
        <div class="jiabin3" :class="jiabindong > 2 ? 'donghua' : ''" @touchstart="touchStart($event, 3)"
          @touchmove="touchMove" @touchend="touchEnd($event, 3)">
          <img src="../static/jiabin/jiabin3.png" class="jiabin-img" alt="">
          <img src="../static/laba.gif" class="laba" alt="">
          <img src="../static/jiabin/tips.png" class="tips" alt="">
        </div>
        <div class="jiabin4">
          <img src="../static/jiabin/jiabin4.png" class="jiabin-img" alt="">
          <img src="../static/laba.gif" class="laba" alt="">
        </div>
        <img src="../static/back.png" class="back" @click="closejiabin" alt="">
      </div>
    </van-overlay>

    <div v-show="fangtan" class="fangtan">
      <video-player class="video-player vjs-custom-skin playerA" @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="fangtan_mp4" :playsinline="true"
        :options="fangtan_mp4">
      </video-player>
      <img src="../static/back.png" class="back" @click="closefangtan" alt="">
      <img src="../static/fangtan1-1.png" class="fangtan1" v-if="selectfangtan == 2" @click="checkmp4(1)" alt="">
      <img src="../static/fangtan1-2.png" class="fangtan1" v-if="selectfangtan == 1" alt="">
      <img src="../static/fangtan2-1.png" class="fangtan2" v-if="selectfangtan == 1" @click="checkmp4(2)" alt="">
      <img src="../static/fangtan2-2.png" class="fangtan2" v-if="selectfangtan == 2" alt="">
      <!-- <img src="../static/skip.png" class="skip" v-if="start" @click="skip" alt=""> -->
    </div>



    <div class="reju" v-show="reju">
      <img src="../static/reju/reju-bg.jpg" class="reju-bg" alt="">
      <img src="../static/reju/reju1.png" class="reju1" @click="openreju_mp4(1)" alt="">
      <img src="../static/reju/reju2.png" class="reju2" @click="openreju_mp4(2)" alt="">
      <img src="../static/reju/reju3.png" class="reju3" @click="openreju_mp4(3)" alt="">
      <img src="../static/reju/reju4.png" class="reju4" @click="openreju_mp4(4)" alt="">
      <img src="../static/reju/reju5.png" class="reju5" @click="openreju_mp4(5)" alt="">
      <img src="../static/reju/reju6.png" class="reju6" @click="openreju_mp4(6)" alt="">
      <img src="../static/reju/reju7.png" class="reju7" @click="openreju_mp4(7)" alt="">
      <img src="../static/hands.png" class="hands" alt="">
      <img src="../static/back.png" class="back" @click="reju = false" alt="">

      <van-overlay :show="showreju_mp4">
        <div class="reju-wrapper" @click.stop>
          <div class="block">
            <video-player class="video-player vjs-custom-skin reju-mp4" @ended="onPlayerEnded($event)"
              @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="reju_mp4" :playsinline="true"
              :options="reju_mp4">
            </video-player>
            <van-icon name="close" class="close" @click="closerejump4" />
          </div>

        </div>
      </van-overlay>
    </div>


    <div class="gushi" v-show="gushi">
      <img src="../static/gushi/gushi-bg.jpg" class="gushi-bg" alt="">
      <img src="../static/gushi/title1.png" v-if="gushi1" class="title1" alt="">
      <img src="../static/gushi/title2.png" v-if="gushi2" class="title2" alt="">
      <img src="../static/gushi/title3.png" v-if="gushi3" class="title3" alt="">
      <img src="../static/gushi/tips.png" v-if="gushi4" class="tips" alt="">
      <img src="../static/back.png" class="back" @click="closegushi" alt="">
    </div>


    <div class="kanxi" v-show="kanxi">
      <video-player class="video-player vjs-custom-skin kanxi-mp4" @ended="onPlayerEnded($event)"
        @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="kanxi_mp4" :playsinline="true"
        :options="kanxi_mp4">
      </video-player>
      <img src="../static/kanxi-bg.jpg" class="kanxi-bg" alt="">
      <img src="../static/back.png" class="back" @click="closekanxi" alt="">


    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jiabinaudio:require("../static/jiabin/jiabin2.mp3"),
      start_but:false,
      start: true,
      music: false,
      but: false,
      title1: false,
      title2: false,
      bottom: false,
      title3: false,
      title4: false,
      title5: false,
      showIllustrate: false,
      fangtan: false,
      xupian: false,
      selectfangtan: 1,
      zhubo: false,
      fangtan_mp4: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/mp4/fangtan1.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      xupian_mp4: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/mp4/xupian.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      zhubo_mp4: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/mp4/zhubo.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      jiabin: false,
      jiabindong: 0,
      clientY: 0,
      reju: false,
      showreju_mp4: false,
      reju_mp4: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/reju/reju1.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      gushi: false,
      gushi1: false,
      gushi2: false,
      gushi3: false,
      gushi4: false,
      kanxi: false,
      kanxi_mp4: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/mp4/kanxi.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      oldScrollTop: 0,
    }
  },

  beforeMount() {


  },
  mounted() {


    setTimeout(() => {
      this.start_but=true
    }, 2000);


  },
  methods: {
    gotohome(){
      console.log(321);
      this.start = false
      this.title1 = true
      this.music = true
      document.getElementById("audio").play()
      setTimeout(() => {
        this.title2 = true
      }, 500)
      setTimeout(() => {
        this.title3 = true
      }, 1000)
      setTimeout(() => {
        this.title4 = true
      }, 1200)
      setTimeout(() => {
        this.title5 = true
      }, 2500)
      setTimeout(() => {
        this.but = true
      }, 3500)
    },

    stopmusic() {
      let audio = document.getElementById("audio");
      if (this.music == true) {
        this.music = false;
        audio.pause();

      } else {
        this.music = true;
        // audio.volume = 0.2;
        audio.play();
      }
    },
    tobottom() {
      var home = document.getElementById("home");
      var homebg = document.getElementById("homebg");
      var scrollDistance = 1.5;
      var height = homebg.offsetHeight;
      var screenHeight = window.innerHeight;
      console.log('相差：', height - screenHeight);

      // console.log('高', height);
      // console.log('屏幕：', screenHeight);
      // console.log('滚轮高度:', home.scrollTop);
      var timer = setInterval(() => {
     
          home.scrollTop = home.scrollTop + scrollDistance
          if (home.scrollTop >= height - screenHeight-1) {
          this.bottom = true
          console.log("到底了");
          clearTimeout(timer);
          
        }
      }, 8)

      // console.log(321, time)
      this.but = false


    },
    toxupian() {
      document.getElementById("audio").pause()
      this.xupian = true
      this.$refs.xupian_mp4.player.play();
    },
    closexupian() {
      this.xupian = false
      this.$refs.xupian_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }

    },
    tozhubo() {
      this.zhubo = true
      document.getElementById("audio").pause()
      this.$refs.zhubo_mp4.player.play();
    },
    closezhubo() {
      this.zhubo = false
      this.$refs.zhubo_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    togushi() {

      this.gushi = true
      this.gushi1 = true
      setTimeout(() => {
        this.gushi2 = true
      }, 1000);
      setTimeout(() => {
        this.gushi3 = true
      }, 2000);
      setTimeout(() => {
        this.gushi4 = true
      }, 3000);

    },
    closegushi() {
      this.gushi = false
      this.gushi1 = false
      this.gushi2 = false
      this.gushi3 = false
      this.gushi4 = false

    },
    onPlayerPlay(e) {
      console.log("播放")

    },
    onPlayerPause(e) {
      console.log("暂停")
    },
    onPlayerEnded(e) {
      console.log("播放结束", e);
    },
    tofangtan() {
      document.getElementById("audio").pause()
      this.fangtan = true
      this.$refs.fangtan_mp4.player.play();
    },
    tojiabin() {
      document.getElementById("audio").pause()
      this.jiabinaudio=require("../static/jiabin/jiabin2.mp3")

      setTimeout(() => {
        document.getElementById("thejiabinaudio").play();
      }, 300);
      
      this.jiabin = true
      this.jiabindong = 0

    },
    closejiabin(){
      document.getElementById("thejiabinaudio").pause()
      this.jiabin=false
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    closefangtan() {
      this.fangtan = false
      this.$refs.fangtan_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    checkmp4(a) {
      if (a == 1) {
        this.selectfangtan = 1
        this.fangtan_mp4.sources[0].src = require("../static/mp4/fangtan1.mp4")
        setTimeout(() => {
          this.$refs.fangtan_mp4.player.play();
        }, 100);

      } else if (a == 2) {
        this.selectfangtan = 2
        this.fangtan_mp4.sources[0].src = require("../static/mp4/fangtan2.mp4")
        setTimeout(() => {
          this.$refs.fangtan_mp4.player.play();
        }, 100);
      }
    },
    touchStart(e, a) {
      e.preventDefault();
      console.log(111, e, a)
      this.clientY = e.changedTouches[0].clientY;
    },
    touchMove(e) { },
    touchEnd(e, a) {
      e.preventDefault();
      console.log(323, e, a)
      if (this.clientY > e.changedTouches[0].clientY) {
        this.jiabindong = a


        if(a==1){
          document.getElementById("thejiabinaudio").pause()
          this.jiabinaudio=require("../static/jiabin/jiabin1.mp3")
          setTimeout(()=>{
            document.getElementById("thejiabinaudio").play()
          },500)
          
        }else if(a==2){
          document.getElementById("thejiabinaudio").pause()
          this.jiabinaudio=require("../static/jiabin/jiabin3.mp3")
          setTimeout(()=>{
            document.getElementById("thejiabinaudio").play()
          },500)
        }
        else if(a==3){
          document.getElementById("thejiabinaudio").pause()
          this.jiabinaudio=require("../static/jiabin/jiabin4.mp3")
          setTimeout(()=>{
            document.getElementById("thejiabinaudio").play()
          },500)
        }
      } else {
        return;
      }
    },
    closerejump4() {
      this.showreju_mp4 = false
      this.$refs.reju_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }

    },
    openreju_mp4(a) {

      this.showreju_mp4 = true
      document.getElementById("audio").pause()

      if (a == 1) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju1.mp4")
      } else if (a == 2) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju2.mp4")
      } else if (a == 3) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju3.mp4")
      } else if (a == 4) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju4.mp4")
      } else if (a == 5) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju5.mp4")
      } else if (a == 6) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju6.mp4")
      } else if (a == 7) {
        this.reju_mp4.sources[0].src = require("../static/reju/reju7.mp4")
      }

      setTimeout(() => {
        this.$refs.reju_mp4.player.play();
      }, 500)


    },
    tokanxi() {
      this.kanxi = true
      document.getElementById("audio").pause()
      this.$refs.kanxi_mp4.player.play();
    },
    closekanxi() {
      this.kanxi = false
      this.$refs.kanxi_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    totop() {
    
      var home = document.getElementById("home");
      var homebg = document.getElementById("homebg");
      var scrollDistance = 1.5; // 500像素
      var height = homebg.offsetHeight;
      var screenHeight = window.innerHeight;
      console.log('相差：', height - screenHeight);
      console.log('滚轮高度:', home.scrollTop);
      var timer = setInterval(() => {

               
          home.scrollTop = home.scrollTop - scrollDistance
          if (home.scrollTop <=0) {
            console.log("到顶了");
            this.but = true
          clearTimeout(timer);
         
        }

      }, 8)

      // let time = (height - screenHeight) / scrollDistance * 15

      // console.log(321, time)
      // setTimeout(() => {
      //   clearTimeout(timer);

      // }, time + 100)
    }
  },

}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  overflow: hidden;

  .start-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;

    .start-title {
      position: absolute;
      width: 280px;
      top: 150px;
    }

    .start-bar {
      position: absolute;
      width: 280px;
      top: 200px;
    }
    .start-but {
      position: absolute;
      width: 140px;
      top: 310px;
    }

  }

  .homebg {
    position: relative;




    .light {
      position: absolute;
      top: 100px;
      left: 50%;
      width: 200px;
      margin-left: -100px;


      animation: light-ani 15s linear infinite;

      @keyframes light-ani {
        0% {
          -webkit-transform: rotate(0deg);
        }

        25% {
          -webkit-transform: rotate(90deg);
        }

        50% {
          -webkit-transform: rotate(180deg);
        }

        75% {
          -webkit-transform: rotate(270deg);
        }

        100% {
          -webkit-transform: rotate(360deg);
        }
      }

    }

    .music {
      position: fixed;
      top: 15px;
      right: 15px;
      width: 40px;
      transform: rotate(250deg);

      &.zhuan {
        animation: turn 2s linear infinite;

        @keyframes turn {
          0% {
            -webkit-transform: rotate(0deg);
          }

          25% {
            -webkit-transform: rotate(90deg);
          }

          50% {
            -webkit-transform: rotate(180deg);
          }

          75% {
            -webkit-transform: rotate(270deg);
          }

          100% {
            -webkit-transform: rotate(360deg);
          }
        }
      }
    }

    .but-box {
      position: absolute;
      width: 100%;
      height: 100vh;

      .but1 {
        width: 140px;
        position: absolute;
        bottom: 120px;
        left: 50%;
        margin-left: -70px;
        animation: but1-ani 1.5s ease backwards;

        @keyframes but1-ani {
          0% {
            opacity: 0;
          }


          100% {
            opacity: 1;
          }
        }
      }

      .but2 {
        width: 140px;
        position: absolute;
        bottom: 60px;
        left: 50%;
        margin-left: -70px;
        animation: but2-ani 1.5s ease backwards;

        @keyframes but2-ani {
          0% {
            opacity: 0;
          }


          100% {
            opacity: 1;
          }
        }
      }
    }

    .bg-img {
      width: 100%;
      display: block;
    }

    .title1 {
      width: 90px;
      position: absolute;
      left: 125px;
      top: 60px;
      animation: title1-ani 1s ease backwards;

      @keyframes title1-ani {
        0% {

          top: -100px;

        }

        100% {

          top: 60px;

        }
      }
    }

    .title2 {
      width: 105px;
      position: absolute;
      left: 160px;
      top: 90px;
      animation: title2-ani 1.5s ease backwards;

      @keyframes title2-ani {
        0% {

          left: 450px;

        }

        100% {

          left: 160px;

        }
      }
    }

    .title3 {
      width: 75px;
      position: absolute;
      left: 120px;
      top: 190px;
      animation: title3-ani 1.5s ease backwards;

      @keyframes title3-ani {
        0% {

          left: -100px;

        }

        100% {

          left: 120px;

        }
      }
    }

    .title4 {
      width: 130px;
      position: absolute;
      left: 130px;
      top: 230px;
      animation: title4-ani 1.5s ease backwards;

      @keyframes title4-ani {
        0% {

          top: 800px;

        }

        100% {

          top: 230px;

        }
      }
    }

    .title5 {
      width: 35px;
      position: absolute;
      left: 75px;
      top: 150px;
      animation: title5-ani 2s ease backwards;

      @keyframes title5-ani {
        0% {

          opacity: 0;

        }

        100% {

          opacity: 1;

        }
      }
    }

    .illustrate-box {
      animation: box1-ani 1.5s ease backwards;

      @keyframes box1-ani {
        0% {
          opacity: 0;
        }


        100% {
          opacity: 1;
        }
      }

      .illustrate {
        width: 60px;
        position: absolute;
        bottom: 460px;
        right: 20px;
      }

      .hands {
        width: 40px;
        position: absolute;
        bottom: 505px;
        right: 20px;
        animation: hands-ani 1s linear infinite;

        @keyframes hands-ani {
          0% {

            width: 40px;
            right: 20px;
          }

          50% {
            width: 30px;
            right: 22px;
          }

          100% {
            width: 40px;
            right: 20px;
          }
        }
      }
    }


    .icon-box {
      width: 76px;
      padding: 25px 8px;
      box-sizing: border-box;
      position: absolute;
      bottom: 70px;
      left: 20px;

      background: url("../static/icon-bg.png") no-repeat;
      background-size: 100% 100%;
      // background-color: rgba(239, 209, 183, 0.586);
      // border-radius: 20px;
      animation: box-ani 1.5s ease backwards;

      @keyframes box-ani {
        0% {
          opacity: 0;
        }


        100% {
          opacity: 1;
        }
      }

      .icon {
        width: 60px;
        margin-bottom: 20px;
      }
      .icon1 {
        width: 50px;
        margin-bottom: 15px;
        margin-left: 5px;
      }

      .icon-bottom {
        margin-left: 10px;
        width: 37px;
      }
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;

    .block {
      background: url("../static/illustrate-bg.png") no-repeat;
      background-size: 100% 100%;
      width: 330px;
      height: 640px;
      position: relative;

      .illustrate-words {
        width: 290px;
        position: absolute;
        top: 60px;
        left: 50%;
        margin-left: -145px;
      }

      .icon1 {
        width: 62px;
        position: absolute;
        top: 100px;
        left: 30px;
      }

      .icon2 {
        width: 60px;
        position: absolute;
        top: 195px;
        left: 30px;
      }

      .icon3 {
        width: 60px;
        position: absolute;
        top: 270px;
        left: 30px;
      }

      .icon4 {
        width: 60px;
        position: absolute;
        top: 350px;
        left: 30px;
      }

      .icon5 {
        width: 60px;
        position: absolute;
        top: 430px;
        left: 30px;
      }

      .icon6 {
        width: 60px;
        position: absolute;
        top: 500px;
        left: 30px;
      }

    }

    .back {
      width: 70px;
      position: absolute;
      top: 40px;
      left: 0;
    }



  }


  .jiabin-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;

    .donghua {
      animation: bg-ani 2s ease 1 forwards;

      @keyframes bg-ani {
        0% {
          top: 0;
        }

        100% {
          top: -230%;
        }
      }
    }

    .tips {
      width: 15px;
      position: absolute;
      top: 540px;
      right: 13px;
      animation: tip-ani 1s linear infinite;

      @keyframes tip-ani {
        0% {
          top: 540px;
        }

        50% {
          top: 530px;
        }

        100% {
          top: 540px;
        }
      }
    }


    .laba {
      width: 30px;
      position: absolute;
      top: 520px;
      left: 190px;
    }

    .jiabin1 {
      position: absolute;
      top: -20px;
      z-index: 5;

      .jiabin-img {
        width: 100%;

      }
    }

    .jiabin2 {
      position: absolute;
      top: -20px;
      z-index: 4;

      .jiabin-img {
        width: 100%;
      }
    }

    .jiabin3 {
      position: absolute;
      top: -20px;
      z-index: 3;

      .jiabin-img {
        width: 100%;
      }
    }

    .jiabin4 {
      position: absolute;
      top: -20px;
      z-index: 2;

      .jiabin-img {
        width: 100%;
      }
    }

    .back {
      width: 70px;
      z-index: 99;
      position: absolute;
      top: 40px;
      left: 0;
    }

  }

  .fangtan {
    width: 100%;
    position: absolute;
    top: 0;

    .fangtan1 {
      width: 72px;
      position: absolute;
      top: 100px;
      left: 0;
    }

    .fangtan2 {
      width: 72px;
      position: absolute;
      top: 140px;
      left: 0;
    }

    .back {
      width: 70px;
      position: absolute;
      top: 40px;
      left: 0;
    }

    .playerA {
      margin: auto auto;
      position: relative;
      display: block;
      // width: 100%;
      height: 100vh;
    }

    /deep/ .video-js .vjs-tech {
      object-fit: fill;
      width: 10rem;
    }

    /deep/ .video-js .vjs-control-bar {
      width: 10rem;
    }

    /deep/ .vjs-poster {
      background-size: cover;
    }


    .video-js {
      background-color: transparent;
      height: 100vh;
      // width: 100%;
    }

    .vjs-poster {
      background-color: transparent;
      cursor: pointer;

    }

    /deep/ .video-js.vjs-fluid {
      width: 10rem;
      // max-width: 100%;
      height: 100vh;
    }

    .vjs-control-bar {
      display: none;
    }
  }


  .reju {
    position: absolute;
    top: 0;
    width: 100%;

    .reju-bg {
      width: 100%;
      height: 100vh;
      display: block;
    }


    .reju-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      position: relative;

      .block {
        .close {
          position: absolute;
          top: 30px;
          right: 20px;
          font-size: 30px;
          color: #fff;
        }

        .reju-mp4 {

          display: block;
        }

        /deep/ .video-js .vjs-tech {
          width: 320px;
          height: 530px;
          position: absolute;
          top: 80px;
          left: 50%;
          margin-left: -160px;
        }


        /deep/ .video-js .vjs-control-bar {
          width: 10rem;
        }

        /deep/ .vjs-poster {
          background-size: cover;
        }

        /deep/.video-js {
          background-color: transparent;
          height: 100vh;
          // width: 100%;
        }

        /deep/ .video-js.vjs-fluid {
          width: 10rem;
          // max-width: 100%;
          height: 100vh;
        }

        .vjs-control-bar {
          display: none;
        }
      }
    }

    .hands {
      position: absolute;
      width: 45px;
      top: 75px;
      left: 250px;
      animation: hands2-ani 1s linear infinite;

      @keyframes hands2-ani {
        0% {

          width: 45px;
          left: 250px;
          top: 75px;
        }

        50% {
          width: 40px;
          left: 252px;
          top: 77px;
        }

        100% {
          width: 45px;
          left: 250px;
          top: 75px;
        }
      }
    }

    .reju1 {
      width: 274px;
      position: absolute;
      top: 110px;
      left: 30px;
      animation: reju1-ani 2s linear infinite;

      @keyframes reju1-ani {
        0% {

          top: 110px;
          left: 30px;
        }

        50% {
          left: 28px;
          top: 107px;
        }

        100% {
          top: 110px;
          left: 30px;
        }
      }

    }

    .reju2 {
      width: 290px;
      position: absolute;
      top: 160px;
      left: 60px;
      animation: reju2-ani 2s linear infinite;

      @keyframes reju2-ani {
        0% {

          top: 160px;
          left: 60px;
        }

        50% {
          left: 58px;
          top: 162px;
        }

        100% {
          top: 160px;
          left: 60px;
        }
      }

    }

    .reju3 {
      width: 215px;
      position: absolute;
      top: 210px;
      left: 20px;
      animation: reju3-ani 2s linear infinite;

      @keyframes reju3-ani {
        0% {

          top: 210px;
          left: 20px;
        }

        50% {
          top: 213px;
          left: 21px;
        }

        100% {
          top: 210px;
          left: 20px;
        }
      }

    }

    .reju4 {
      width: 249px;
      position: absolute;
      top: 260px;
      left: 70px;
      animation: reju4-ani 2s linear infinite;

      @keyframes reju4-ani {
        0% {

          top: 260px;
          left: 70px;
        }

        50% {
          top: 259px;
          left: 73px;
        }

        100% {
          top: 260px;
          left: 70px;
        }
      }

    }

    .reju5 {
      width: 274px;
      position: absolute;
      top: 320px;
      left: 30px;
      animation: reju5-ani 2s linear infinite;

      @keyframes reju5-ani {
        0% {
          width: 274px;
          top: 320px;
          left: 30px;
        }

        50% {
          width: 276px;
          top: 321px;
          left: 28px;
        }

        100% {
          width: 274px;
          top: 320px;
          left: 30px;
        }
      }

    }

    .reju6 {
      width: 265px;
      position: absolute;
      top: 380px;
      left: 60px;
      animation: reju6-ani 2s linear infinite;

      @keyframes reju6-ani {
        0% {

          top: 380px;
          left: 60px;
        }

        50% {
          top: 384px;
          left: 58px;
        }

        100% {
          top: 380px;
          left: 60px;
        }
      }

    }

    .reju7 {
      width: 306px;
      position: absolute;
      top: 445px;
      left: 15px;
      animation: reju7-ani 2s linear infinite;

      @keyframes reju7-ani {
        0% {

          top: 445px;
          left: 15px;
        }

        50% {
          top: 445px;
          left: 17px;
        }

        100% {
          top: 445px;
          left: 15px;
        }
      }

    }

    .back {
      width: 70px;
      position: absolute;
      top: 40px;
      left: 0;
    }
  }


  .gushi {
    position: absolute;
    top: 0;
    width: 100%;

    .gushi-bg {
      width: 100%;
      display: block;
    }

    .title1 {
      position: absolute;
      width: 248px;
      top: 90px;
      left: 30px;
      animation: gushi1-ani 1.5s ease backwards;

      @keyframes gushi1-ani {
        0% {
          opacity: 0;
        }


        100% {
          opacity: 1;
        }
      }
    }

    .title2 {
      position: absolute;
      width: 251px;
      top: 125px;
      left: 25px;
      animation: gushi2-ani 1.5s ease backwards;

      @keyframes gushi2-ani {
        0% {
          left: -225px;
        }


        100% {
          left: 25px;
        }
      }
    }

    .title3 {
      position: absolute;
      width: 158px;
      top: 245px;
      left: 25px;
      animation: gushi3-ani 1.5s ease backwards;

      @keyframes gushi3-ani {
        0% {
          opacity: 0;
        }


        100% {
          opacity: 1;
        }
      }
    }

    .tips {
      position: absolute;
      width: 15px;
      top: 450px;
      right: 25px;
      animation: gushi4-ani 1s linear infinite;

      @keyframes gushi4-ani {
        0% {
          top: 450px;
        }


        100% {
          top: 420px;
        }
      }
    }

    .back {
      width: 70px;
      position: fixed;
      top: 40px;
      left: 0;
    }
  }

  .kanxi {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;

    .back {
      width: 70px;
      position: absolute;
      top: 40px;
      left: 0;
    }

    .kanxi-bg {
      width: 100%;
      display: block;
    }

    .kanxi-mp4 {
      position: absolute;
      top: 213px;
      left: 30px;
      width: 315px;
      // height: 180px;
    }

    // /deep/.video-js {
    //   width: 315px;
    //   height: 180px;
    // }
    // /deep/.video-js.vjs-fluid{
    //   width: 100%;
    //   max-width: 315px;
    //   height: 100%;
    //   max-height: 180px;
    // }
    // /deep/.video-js .vjs-tech{
    //   width: 100%;
    //   max-width: 315px;
    //   height: 100%;
    //   max-height: 180px;
    //   margin: auto;

    // }
    // /deep/.video-js .vjs-control-bar{
    //   width: 100%;
    // }
  }




  /deep/ .vjs-big-play-button {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    ;
  }
}
</style>